var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 664 367",
    width: 664,
    height: 367,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 205.000,224.125 C 210.751,219.752 210.000,219.125 215.000,214.125",
    strokeWidth: 2.679,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 215.000,214.125 C 227.884,194.171 229.251,195.252 242.000,175.125",
    strokeWidth: 1.713,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 242.000,175.125 C 260.936,152.794 259.384,151.671 278.000,129.125",
    strokeWidth: 1.326,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 278.000,129.125 C 292.454,109.909 291.936,109.794 304.000,89.125",
    strokeWidth: 1.429,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 304.000,89.125 C 312.757,73.554 312.454,73.909 318.000,57.125",
    strokeWidth: 1.695,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 318.000,57.125 C 320.090,49.028 320.257,50.054 319.000,42.125",
    strokeWidth: 2.43,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 319.000,42.125 C 317.627,38.353 318.590,39.528 315.000,38.125",
    strokeWidth: 3.426,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 315.000,38.125 C 304.677,36.459 306.127,37.353 296.000,40.125",
    strokeWidth: 2.842,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 296.000,40.125 C 266.666,49.644 269.177,51.459 244.000,68.125",
    strokeWidth: 1.451,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 244.000,68.125 C 198.854,102.964 201.666,102.644 166.000,146.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 166.000,146.125 C 147.485,173.057 147.854,169.964 142.000,202.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 142.000,202.125 C 137.620,229.603 137.485,226.057 146.000,252.125",
    strokeWidth: 1.307,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 146.000,252.125 C 155.657,276.333 153.620,272.603 174.000,288.125",
    strokeWidth: 1.411,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 174.000,288.125 C 201.307,303.918 197.657,303.333 230.000,306.125",
    strokeWidth: 1.303,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 230.000,306.125 C 268.159,306.829 266.307,308.918 304.000,298.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 304.000,298.125 C 339.541,289.366 338.159,289.829 370.000,272.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 370.000,272.125 C 396.835,258.771 392.541,259.366 410.000,238.125",
    strokeWidth: 1.262,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 410.000,238.125 C 421.175,217.076 418.835,224.271 414.000,203.125",
    strokeWidth: 1.613,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 414.000,203.125 C 397.136,180.099 403.175,182.076 374.000,168.125",
    strokeWidth: 1.381,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 374.000,168.125 C 338.039,150.609 340.136,150.599 300.000,144.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 300.000,144.125 C 248.646,134.632 250.039,135.609 198.000,138.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 198.000,138.125 C 127.817,139.447 132.646,142.632 68.000,160.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 68.000,160.125 C 42.883,174.973 46.817,167.447 36.000,194.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 36.000,194.125 C 34.691,213.642 31.383,206.973 45.000,224.125",
    strokeWidth: 1.59,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 45.000,224.125 C 67.949,244.657 64.191,243.642 95.000,254.125",
    strokeWidth: 1.396,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 95.000,254.125 C 129.789,262.604 127.949,265.657 165.000,266.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 165.000,266.125 C 190.047,266.881 189.789,268.604 215.000,266.125",
    strokeWidth: 1.281,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 215.000,266.125 C 227.356,264.854 223.047,265.881 231.000,264.125",
    strokeWidth: 2.098,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 231.000,264.125 C 227.271,262.763 232.356,263.854 225.000,264.125",
    strokeWidth: 3.587,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 225.000,264.125 C 219.007,268.986 222.271,265.763 221.000,270.125",
    strokeWidth: 3.833,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 221.000,270.125 C 230.029,272.367 226.007,272.986 239.000,272.125",
    strokeWidth: 4.273,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 239.000,272.125 C 248.609,271.117 248.529,271.867 258.000,269.125",
    strokeWidth: 2.905,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 258.000,269.125 C 264.964,266.977 265.109,267.617 272.000,265.125",
    strokeWidth: 2.991,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 272.000,265.125 C 275.136,265.575 274.464,264.477 277.000,264.125",
    strokeWidth: 3.816,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 277.000,264.125 C 278.500,260.625 279.636,262.075 281.000,258.125",
    strokeWidth: 4.784,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 281.000,258.125 C 283.851,255.842 283.500,255.625 287.000,254.125",
    strokeWidth: 5.138,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 287.000,254.125 C 289.708,253.520 289.351,252.842 292.000,252.125",
    strokeWidth: 4.45,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 292.000,252.125 C 301.080,246.242 301.208,246.520 310.000,240.125",
    strokeWidth: 2.855,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 310.000,240.125 C 318.790,234.469 318.580,234.242 327.000,228.125",
    strokeWidth: 2.487,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 327.000,228.125 C 330.598,222.424 329.790,225.969 332.000,223.125",
    strokeWidth: 3.332,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 332.000,223.125 C 332.809,227.106 333.598,223.924 333.000,231.125",
    strokeWidth: 4.249,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 333.000,231.125 C 333.000,237.625 333.309,237.606 333.000,244.125",
    strokeWidth: 3.376,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M 333.000,244.125 C 330.750,251.266 333.000,247.625 333.000,251.125",
    strokeWidth: 3.735,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M 333.000,251.125 C 341.091,247.299 338.750,250.766 349.000,243.125",
    strokeWidth: 3.982,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M 349.000,243.125 C 358.941,237.513 359.091,237.799 369.000,232.125",
    strokeWidth: 2.65,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M 369.000,232.125 C 376.000,227.125 372.941,230.013 377.000,228.125",
    strokeWidth: 3.299,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M 377.000,228.125 C 374.539,231.949 378.000,229.125 373.000,236.125",
    strokeWidth: 4.208,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M 373.000,236.125 C 368.779,243.158 371.039,241.449 370.000,247.125",
    strokeWidth: 3.516,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M 370.000,247.125 C 373.829,250.455 370.779,249.658 377.000,249.125",
    strokeWidth: 4.388,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M 377.000,249.125 C 389.517,242.358 389.329,243.955 401.000,234.125",
    strokeWidth: 2.5,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M 401.000,234.125 C 416.869,223.958 416.017,223.358 430.000,211.125",
    strokeWidth: 1.879,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M 430.000,211.125 C 437.627,201.215 438.869,202.458 445.000,191.125",
    strokeWidth: 2.141,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M 445.000,191.125 C 450.361,183.888 447.127,188.215 449.000,185.125",
    strokeWidth: 3.118,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M 449.000,185.125 C 440.587,192.407 444.861,188.888 434.000,201.125",
    strokeWidth: 3.323,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M 434.000,201.125 C 423.286,214.982 423.587,214.907 415.000,230.125",
    strokeWidth: 2.134,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M 415.000,230.125 C 408.860,241.843 408.786,241.482 405.000,254.125",
    strokeWidth: 2.196,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M 405.000,254.125 C 403.664,259.747 403.360,259.343 404.000,265.125",
    strokeWidth: 2.925,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M 404.000,265.125 C 404.046,270.776 404.164,267.747 406.000,270.125",
    strokeWidth: 4.08,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M 406.000,270.125 C 414.508,265.279 413.046,267.776 422.000,259.125",
    strokeWidth: 2.865,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M 422.000,259.125 C 443.123,242.772 442.508,242.279 462.000,224.125",
    strokeWidth: 1.556,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M 462.000,224.125 C 484.224,202.139 484.123,202.272 504.000,178.125",
    strokeWidth: 1.293,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M 504.000,178.125 C 526.492,151.123 526.224,151.139 546.000,122.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M 546.000,122.125 C 565.170,96.515 563.492,96.123 578.000,68.125",
    strokeWidth: 1.133,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M 578.000,68.125 C 588.038,42.485 588.670,44.515 593.000,18.125",
    strokeWidth: 1.257,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M 593.000,18.125 C 590.829,12.492 593.538,15.485 589.000,14.125",
    strokeWidth: 2.597,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M 589.000,14.125 C 575.941,27.845 576.829,24.992 565.000,43.125",
    strokeWidth: 1.877,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M 565.000,43.125 C 548.452,69.432 546.941,68.345 531.000,95.125",
    strokeWidth: 1.353,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M 531.000,95.125 C 511.185,121.588 512.452,122.432 493.000,149.125",
    strokeWidth: 1.206,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M 493.000,149.125 C 476.198,174.669 476.185,174.588 461.000,201.125",
    strokeWidth: 1.219,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M 461.000,201.125 C 449.061,221.705 449.198,221.669 439.000,243.125",
    strokeWidth: 1.353,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M 439.000,243.125 C 434.170,255.031 433.561,254.705 430.000,267.125",
    strokeWidth: 1.873,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M 430.000,267.125 C 430.735,270.534 429.170,269.531 429.000,272.125",
    strokeWidth: 3.291,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M 429.000,272.125 C 423.956,276.735 424.735,276.034 418.000,278.125",
    strokeWidth: 4.407,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M 418.000,278.125 C 408.509,278.961 408.956,280.235 399.000,279.125",
    strokeWidth: 2.937,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M 399.000,279.125 C 379.500,279.125 379.509,279.461 360.000,279.125",
    strokeWidth: 1.887,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M 360.000,279.125 C 334.000,279.125 334.000,279.125 308.000,279.125",
    strokeWidth: 1.506,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M 308.000,279.125 C 285.000,279.125 285.000,279.125 262.000,279.125",
    strokeWidth: 1.467,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M 262.000,279.125 C 250.000,279.125 250.000,279.125 238.000,279.125",
    strokeWidth: 1.94,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M 238.000,279.125 C 230.544,278.309 234.000,279.125 230.000,279.125",
    strokeWidth: 2.961,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M 230.000,279.125 C 232.810,281.168 229.544,279.809 236.000,282.125",
    strokeWidth: 4.302,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M 236.000,282.125 C 242.891,284.354 242.810,284.168 250.000,285.125",
    strokeWidth: 3.273,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M 250.000,285.125 C 284.420,289.966 284.391,288.854 319.000,291.125",
    strokeWidth: 1.383,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M 319.000,291.125 C 374.000,291.125 373.920,292.966 429.000,291.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M 429.000,291.125 C 519.008,291.802 519.000,291.125 609.000,291.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.946a2dd93131a8779294d14359ea9c4a.svg";
export { ForwardRef as ReactComponent };